<template>
  <v-slide-y-reverse-transition hide-on-leave>
    <v-checkbox v-if="inItemsView" v-model="onlyBestPrediction" :label="label" hide-details />
  </v-slide-y-reverse-transition>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapState } = createNamespacedHelpers("classifier");

export default {
  computed: {
    ...mapState(["currentClassification", "onlyItemsWithTheirBestPrediction"]),
    inItemsView() {
      return this.$route.name === "classifier/predictions/items";
    },
    /**
     * The label for the checkbox that indicates the classification's name.
     */
    label() {
      return this.currentClassification
        ? `Solamente QMIs que tengan como mejor predicción a la clasificación "${this.currentClassification.name}"`
        : `Solamente QMIs que tengan su mejor predicción en esta clasificación`;
    },
    /**
     * Map the state of the checkbox with the store.
     */
    onlyBestPrediction: {
      get() {
        return this.onlyItemsWithTheirBestPrediction;
      },
      set(value) {
        return this.setOnlyItemsWithTheirBestPrediction(value);
      }
    }
  },
  methods: {
    ...mapMutations(["setOnlyItemsWithTheirBestPrediction"])
  }
};
</script>
